import { useId, useState } from 'react'
import type { ReactNode } from 'react'
import { cx } from '../../cx'
import styles from './Accordion.module.css'

export interface AccordionItem {
  key: string
  question: ReactNode
  answer: ReactNode
}

export interface AccordionProps {
  items: readonly AccordionItem[]
  /** Indeks pozycji otwartej na start; -1 = wszystko zamknięte (spec 07). */
  defaultOpenIndex?: number
  className?: string
}

/** Akordeon single-open: klik w otwartą pozycję zamyka wszystko. */
export function Accordion({ items, defaultOpenIndex = 0, className }: AccordionProps) {
  const [openIndex, setOpenIndex] = useState(defaultOpenIndex)
  const baseId = useId()

  return (
    <div className={cx(styles.list, className)}>
      {items.map((item, index) => {
        const open = index === openIndex
        const panelId = `${baseId}-panel-${index}`
        const triggerId = `${baseId}-trigger-${index}`
        return (
          <div key={item.key} className={styles.item}>
            <h3>
              <button
                type="button"
                id={triggerId}
                className={styles.trigger}
                aria-expanded={open}
                aria-controls={panelId}
                onClick={() => setOpenIndex(open ? -1 : index)}
              >
                {item.question}
                <span className={cx(styles.icon, open && styles.iconOpen)} aria-hidden="true">
                  +
                </span>
              </button>
            </h3>
            {open ? (
              <div id={panelId} role="region" aria-labelledby={triggerId} className={styles.panel}>
                {item.answer}
              </div>
            ) : null}
          </div>
        )
      })}
    </div>
  )
}
